export const MOBILE_SIZE = 500
export const TABLET_SIZE = 768
